<template>
	<div>
		<!--Loading-->
		<b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

		<PageTitle title="Users" />
		<div class="columns">
			<div class="column is-12">
				<div class="card">
					<div class="card-content">
						<UpTable :paginated="true" :per-page="10" :data="fetchUsers" searchable>
							<UpTableColumn v-slot="props" field="name" label="Name" sortable><small>{{props.row.name}}</small></UpTableColumn>
							<UpTableColumn v-slot="props" field="email" label="Email" sortable><small>{{props.row.email}}</small></UpTableColumn>
							<UpTableColumn v-slot="props" field="mobile" label="Mobile" sortable><small>{{props.row.mobile}}</small></UpTableColumn>
							<UpTableColumn v-slot="props" field="created_at" label="Registered" sortable>
								<small>{{$common.formatDate(props.row.created_at)}}</small>
							</UpTableColumn>
							<UpTableColumn v-slot="props" field="no_kids" label="Kids" sortable><small>{{props.row.no_kids}}</small></UpTableColumn>
							<template #empty>
								<empty-table message="No users found."></empty-table>
							</template>
						</UpTable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'

export default {
	name : 'User',
	components : {
		PageTitle, EmptyTable
	},
	data(){
		return {
			isLoading : false
		}
	},
	computed : {
		...mapGetters(['fetchUsers', 'getTeacherToken'])
	},
	methods : {
		...mapActions(['loadUsers']),
	},
	async created(){
		this.isLoading = true
		await this.loadUsers({ token : this.getTeacherToken })
		this.isLoading = false
	}
	
}
</script>